import CoreDrawer from '@/components/CoreDrawer';
import { Spin } from 'antd';
import { get } from 'lodash';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import GetDetailCity from '../../viewmodels/city-detail.viewmodel';
import { CityForm } from './CityForm';

interface Props {
  open: boolean;
  handleClose: () => void;
  setOpen: (value: boolean) => void;
}

export const DetailCity = (props: Props) => {
  const { open, setOpen, handleClose } = props;
  const { loadingCity, errorCity, detailCity, actionGetDetail } = GetDetailCity();
  console.log('detailCity :>> ', detailCity);
  console.log('errorCity :>> ', errorCity);

  const [currentQueryParameters] = useSearchParams();
  const showId = currentQueryParameters.get('id');
  const getAction = currentQueryParameters.get('action');

  useEffect(() => {
    if ((showId !== null && getAction === 'Detail') || getAction === 'Create') {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [open, handleClose, setOpen]);

  useEffect(() => {
    if (showId) {
      actionGetDetail();
    }
  }, [open]);

  const renderContent = () => {
    return (
      <>
        <div>{loadingCity && <Spin />}</div>
        {errorCity && <div>Error</div>}
        {!errorCity && !loadingCity && (
          <CityForm detailCity={get(detailCity, 'data')} openForm={open} />
        )}
      </>
    );
  };

  return (
    <CoreDrawer
      open={open}
      onClose={() => handleClose()}
      content={renderContent()}
      bodyStyle={{ marginTop: '20px' }}
    />
  );
};
